// Section copy definitions

const sectionsCopy = {
  introduction: {
    subtitle: 'What Drives Us',
    content: [
      '"We create games for the Soul."',
      'This reflects our drive to craft emotionally unforgettable gaming experiences for all players. We draw on our team\'s diverse perspectives to build heart-pounding action, chilling suspense, and powerful narratives that move the soul.',
      'Our mission is to redefine what games can mean through innovation and connection with our players.'
    ]
  },
  genesis: {
    subtitle: 'Where It Began',
    heading: 'Genesis',
    content: [
      'It started in a small apartment in Corpus Christi, where late nights and passionate conversations about storytelling gave birth to something extraordinary.',
      'Two dreamers with a shared vision: to create games that matter, games that leave lasting impressions on the soul.'
    ]
  },
  values: {
    subtitle: 'Heart of the Studio',
    heading: 'Our Values',
    content: [
      'Authenticity drives everything we do. We believe in honest storytelling, genuine emotion, and the power of vulnerability in art. Our games explore the complexity of human experience—fear, love, loss, hope—with the respect and depth these themes deserve.',
      'We are committed to creating safe spaces for both our team and our players to explore difficult emotions and find catharsis through interactive narrative. Every story we tell is a bridge between hearts, connecting players to something deeper within themselves.'
    ]
  },
  joinTeam: {
    heading: 'Join the Team',
    content: 'We\'re looking for passionate creators who believe in the transformative power of games.',
    cta: 'Interested? Apply Now',
    departments: {
      art: 'Art',
      engineering: 'Engineering', 
      design: 'Design',
      narrative: 'Narrative'
    },
    jobs: [
      { title: 'Character Modeler', location: 'US Remote', department: 'Art' },
      { title: 'Concept Artist', location: 'US Remote', department: 'Art' },
      { title: 'Lead Unreal Engineer', location: 'US Remote', department: 'Engineering' },

    ]
  },
  team: {
    heading: 'Meet the Team',
    foundersHeading: 'Founders',
    teamHeading: 'Team Members',
    founders: [
      {
        name: 'Julio Aguilar',
        role: 'CEO',
        bio: 'Julio Aguilar is the founder, visionary, and creative director of Quintessence Games, and a lifelong gaming enthusiast.',
        imageAlt: 'Portrait of Julio Aguilar, CEO and Founder'
      },
      {
        name: 'Jonathan Hight',
        role: 'COO',
        bio: 'Jonathan Hight is an operations and production expert with 20+ years in the industry, working on AAA titles for some of the world\'s biggest studios.',
        imageAlt: 'Portrait of Jonathan Hight, Chief Operating Officer'
      },
      {
        name: 'Mitchell Potter',
        role: 'CTO',
        bio: 'Mitchell Potter is a technology visionary with 20+ years of game simulation and software engineering, ranging from AAA titles to major hardware companies.',
        imageAlt: 'Portrait of Mitchell Potter, Chief Technology Officer'
      },
      {
        name: 'Frankie Cruz',
        role: 'CFO',
        bio: 'Frankie Cruz is an investment and corporate finance expert, specializing in mergers and acquisitions and financial modeling, with successful exit-stage experience.',
        imageAlt: 'Portrait of Frankie Cruz, Chief Financial Officer'
      }
    ],
    members: [
      {
        name: 'Casey Weidner',
        role: 'Engineer',
      },
      {
        name: 'Charles Baker',
        role: 'Jr. Engineer',
      },
      {
        name: 'Jim Diaz',
        role: 'Audio Director',
      },
      {
        name: 'Sean Ashcraft',
        role: 'IT Manager',
      },
      {
        name: 'Zachary Sartor-Duchene',
        role: 'Art Director',
      },
      {
        name: 'Chris Hepler',
        role: 'Writing Director',
      },
    ]
  },
  contact: {
    heading: 'Contact',
    placeholder: 'Tell us about your project ideas, collaboration opportunities, or just say hello...',
    submit: 'Send Message',
    emailText: 'To get in touch, email our COO, Jonathan Hight, at',
    email: 'jonathan.hight@gmail.com'
  }
};

export default sectionsCopy;
